// Theme Actions
export const SET_MODE = 'SET_MODE';
export const SET_COLOR = 'SET_COLOR';
export const GET_THEME = 'GET_THEME';

// Sidebar Menu Actions
export const SHOW_SIDEBAR_MENU = 'SHOW_SIDEBAR_MENU';

// Settings Action
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

// Session Actions
export const UPDATE_SERVER = 'UPDATE_SERVER';
export const UPDATE_USER = 'UPDATE_USER';

// Devices Actions
export const REFRESH_DEVICES = 'REFRESH_DEVICES';
export const UPDATE_DEVICES = 'UPDATE_DEVICES';
export const SELECT_DEVICE = 'SELECT_DEVICE';
export const FOLLOW_DEVICE = 'FOLLOW_DEVICE';
export const REMOVE_DEVICE = 'REMOVE_DEVICE';
export const SHOW_ROUTES_FILTER = 'SHOW_ROUTES_FILTER';

// Positions Actions
export const UPDATE_POSITIONS = 'UPDATE_POSITIONS';
export const UPDATE_ADDRESS = 'UPDATE_ADDRESS';

// Drivers Actions
export const UPDATE_DRIVERS = 'UPDATE_DRIVERS';

// Geofences Actions
export const REFRESH_GEOFENCES = 'REFRESH_GEOFENCES';
export const UPDATE_GEOFENCES = 'UPDATE_GEOFENCES';

// Groups Actions
export const UPDATE_GROUPS = 'UPDATE_GROUPS';

// Maintenance Actions
export const UPDATE_MAINTENANCES = 'UPDATE_MAINTENANCES';

// Assets Actions
export const REFRESH_ASSETS = 'REFRESH_ASSETS';
export const UPDATE_ASSETS = 'UPDATE_ASSETS';
export const SELECT_ASSET = 'SELECT_ASSETS';
export const FOLLOW_ASSET = 'FOLLOW_ASSETS';
export const REMOVE_ASSET = 'REMOVE_ASSETS';